export default "__VITE_ASSET__ad9aa628__"